import { render, staticRenderFns } from "./SubProcess.vue?vue&type=template&id=0a597c29&scoped=true&"
import script from "./SubProcess.vue?vue&type=script&lang=js&"
export * from "./SubProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a597c29",
  null
  
)

export default component.exports